<template>
  <div class="col-sm-12">
    <div class="card">
      <div class="card-header card-no-border">
        <div class="header-top">
          <h5>Distributors, Authorized Dealers and Competitors</h5>

          <div class="d-flex align-items-center gap-2">
            <button
              type="button"
              class="see-more-btn"
              @click="seeMore"
            >
              <i class="fas fa-map-marker-alt"></i>
              &nbsp; Filtering
            </button>

            <div
              ref="dropdownContainer"
              class="dropdown-container"
            >
              <button
                type="button"
                class="menu-btn"
                @click="toggleMenu"
              >
                <i class="fas fa-ellipsis-v"></i>
              </button>

              <div
                v-if="menuOpen"
                class="custom-dropdown"
              >
                <div
                  class="dropdown-item"
                  @click="toggleLayer('distributors')"
                >
                  <span
                    :class="
                      showDistributors
                        ? 'text-danger'
                        : 'text-muted'
                    "
                  >
                    <i
                      :class="
                        showDistributors
                          ? 'fas fa-eye'
                          : 'fas fa-eye-slash'
                      "
                    ></i>
                  </span>

                  {{ showDistributors ? "Hide" : "Show" }}
                  Distributors
                </div>

                <div
                  class="dropdown-item"
                  @click="toggleLayer('dealers')"
                >
                  <span
                    :class="
                      showDealers
                        ? 'text-warning'
                        : 'text-muted'
                    "
                  >
                    <i
                      :class="
                        showDealers
                          ? 'fas fa-eye'
                          : 'fas fa-eye-slash'
                      "
                    ></i>
                  </span>

                  {{ showDealers ? "Hide" : "Show" }}
                  Dealers
                </div>

                <div
                  class="dropdown-item"
                  @click="toggleLayer('competitors')"
                >
                  <span
                    :class="
                      showCompetitors
                        ? 'text-primary'
                        : 'text-muted'
                    "
                  >
                    <i
                      :class="
                        showCompetitors
                          ? 'fas fa-eye'
                          : 'fas fa-eye-slash'
                      "
                    ></i>
                  </span>

                  {{ showCompetitors ? "Hide" : "Show" }}
                  Competitors
                </div>

                <div
                  class="dropdown-item"
                  @click="toggleLayer('dual')"
                >
                  <span
                    :class="
                      showDual
                        ? 'text-success'
                        : 'text-muted'
                    "
                  >
                    <i
                      :class="
                        showDual
                          ? 'fas fa-eye'
                          : 'fas fa-eye-slash'
                      "
                    ></i>
                  </span>

                  {{ showDual ? "Hide" : "Show" }}
                  Dual
                </div>
              </div>
            </div>

            <Teleport to="body">
              <DealerMapModal
                v-if="showMapPopup"
                @close-modal="closeModal"
              />
            </Teleport>
          </div>
        </div>
      </div>

      <div class="card-body pt-0">
        <div
          v-if="loading"
          class="spinner-container"
        >
          <div class="spinner"></div>
        </div>

        <div
          v-if="error"
          class="error-container"
        >
          <img
            src="../../../../assets/vectors/data_not_found.png"
            alt="Error"
            class="error-image"
          />

          <p class="error-message">
            {{ error }}
          </p>
        </div>

        <div v-show="!loading && !error">
          <div
            id="map"
            ref="mapContainer"
            class="map"
          ></div>

          <div class="map-legend">
            <div
              v-if="showDistributors"
              class="legend-item"
            >
              <span class="legend-icon distributor"></span>

              <span>
                Distributors
                ({{ distributors_with_location_count }}/{{
                  distributors_count
                }})
              </span>
            </div>

            <div
              v-if="showDealers"
              class="legend-item hover-tooltip"
            >
              <span class="legend-icon dealer"></span>

              <span>
                Dealers
                ({{ dealers_with_location_count }}/{{
                  dealers_count
                }})
              </span>

              <div class="dealers-tooltip">
                <div class="tooltip-row">
                  <span>Normal:</span>

                  <span>
                    {{ normal_dealers_with_location_count }}/{{
                      normal_dealers_count
                    }}
                  </span>
                </div>

                <div class="tooltip-row">
                  <span>Commercial:</span>

                  <span>
                    {{ commercial_dealers_with_location_count }}/{{
                      commercial_dealers_count
                    }}
                  </span>
                </div>
              </div>
            </div>

            <div
              v-if="showCompetitors"
              class="legend-item hover-tooltip"
            >
              <span class="legend-icon competitor"></span>

              <span>
                Competitors
                ({{ competitors_with_location_count }}/{{
                  competitors_count
                }})
              </span>

              <div class="dealers-tooltip">
                <div class="tooltip-row">
                  <span>Dealers:</span>

                  <span>
                    {{ competitor_dealers_with_location_count }}/{{
                      competitor_dealers
                    }}
                  </span>
                </div>

                <div class="tooltip-row">
                  <span>Distributors:</span>

                  <span>
                    {{ competitor_distributors_with_location_count }}/{{
                      competitor_distributors
                    }}
                  </span>
                </div>
              </div>
            </div>

            <div
              v-if="showDual"
              class="legend-item"
            >
              <span class="legend-icon dual"></span>

              <span>
                Dual
                ({{ dual_with_location_count }}/{{ dual_count }})
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DealerMapModal from "@/pages/Modal/maps/dealerMapModal.vue";
import { fetchDealersAndCompetitors } from "@/services/dataService";

export default {
  name: "DealerDistributionMap",

  components: {
    DealerMapModal,
  },

  data() {
    return {
      token: localStorage.getItem("token_set"),
      profileId: localStorage.getItem("profile_id"),
      userCategory: localStorage.getItem("user_label"),

      loading: false,
      error: null,
      showMapPopup: false,

      mapsApiReady: false,
      dataReady: false,

      menuOpen: false,

      /*
       * These values are assigned again after
       * the API response based on the login type.
       */
      showDistributors: false,
      showDealers: false,
      showCompetitors: false,
      showDual: false,

      dealers: [],
      competitors: [],
      dual: [],
      distributors: [],

      dealers_count: 0,
      dealers_with_location_count: 0,

      normal_dealers_count: 0,
      normal_dealers_with_location_count: 0,

      commercial_dealers_count: 0,
      commercial_dealers_with_location_count: 0,

      competitors_count: 0,
      competitors_with_location_count: 0,

      competitor_dealers: 0,
      competitor_dealers_with_location_count: 0,

      competitor_distributors: 0,
      competitor_distributors_with_location_count: 0,

      dual_count: 0,
      dual_with_location_count: 0,

      distributors_count: 0,
      distributors_with_location_count: 0,
    };
  },

  computed: {
    normalizedUserCategory() {
      return String(
        this.userCategory || "",
      )
        .toUpperCase()
        .trim();
    },

    isDistributorLogin() {
      return [
        "DISTRIBUTOR",
        "DISTRIBUTOR BACK OFFICE",
      ].includes(
        this.normalizedUserCategory,
      );
    },
  },

  created() {
    /*
     * Google Maps objects are intentionally
     * kept outside Vue's reactive data.
     */
    this.map = null;

    this.distributorMarkers = [];
    this.dealerMarkers = [];
    this.competitorMarkers = [];
    this.dualMarkers = [];

    this.sharedInfoWindow = null;
    this.iconCache = {};
  },

  watch: {
    showMapPopup(newValue) {
      document.body.style.overflow =
        newValue ? "hidden" : "";
    },
  },

  mounted() {
    this.loadGoogleMaps();
    this.fetchMapData();

    document.addEventListener(
      "click",
      this.handleClickOutside,
    );
  },

  beforeUnmount() {
    document.body.style.overflow = "";

    document.removeEventListener(
      "click",
      this.handleClickOutside,
    );

    this.clearAllMarkers();

    if (this.sharedInfoWindow) {
      this.sharedInfoWindow.close();
    }
  },

  methods: {
    toggleMenu() {
      this.menuOpen = !this.menuOpen;
    },

    handleClickOutside(event) {
      const container =
        this.$refs.dropdownContainer;

      if (
        container &&
        !container.contains(event.target)
      ) {
        this.menuOpen = false;
      }
    },

    toggleLayer(type) {
      let markersToToggle = [];
      let isVisible = false;

      switch (type) {
        case "distributors":
          this.showDistributors =
            !this.showDistributors;

          markersToToggle =
            this.distributorMarkers;

          isVisible =
            this.showDistributors;
          break;

        case "dealers":
          this.showDealers =
            !this.showDealers;

          markersToToggle =
            this.dealerMarkers;

          isVisible =
            this.showDealers;
          break;

        case "competitors":
          this.showCompetitors =
            !this.showCompetitors;

          markersToToggle =
            this.competitorMarkers;

          isVisible =
            this.showCompetitors;
          break;

        case "dual":
          this.showDual =
            !this.showDual;

          markersToToggle =
            this.dualMarkers;

          isVisible =
            this.showDual;
          break;

        default:
          return;
      }

      markersToToggle.forEach((marker) => {
        marker.setMap(
          isVisible ? this.map : null,
        );
      });

      this.menuOpen = false;

      this.$nextTick(() => {
        setTimeout(() => {
          this.fitMapToVisibleMarkers();
        }, 150);
      });
    },

    tryInitMap() {
      if (
        this.mapsApiReady &&
        this.dataReady
      ) {
        this.$nextTick(() => {
          this.initMap();
        });
      }
    },

    getIcon(
      color,
      strokeColor = null,
      strokeWidth = 0,
    ) {
      const cacheKey =
        `${color}_` +
        `${strokeColor || "none"}_` +
        `${strokeWidth}`;

      if (!this.iconCache[cacheKey]) {
        this.iconCache[cacheKey] =
          this.createCustomIcon(
            color,
            strokeColor,
            strokeWidth,
          );
      }

      return this.iconCache[cacheKey];
    },

    getDistributorIcon() {
      if (
        !this.iconCache.distributor
      ) {
        this.iconCache.distributor =
          this.createDistributorIcon();
      }

      return this.iconCache.distributor;
    },

    getDealerIcon(dealerCategory) {
      const category =
        Number(dealerCategory);

      /*
       * Commercial dealer:
       * yellow marker with a black outline.
       */
      if (category === 2) {
        return this.getIcon(
          "#f4b400",
          "#000000",
          12,
        );
      }

      /*
       * Normal dealer.
       */
      return this.getIcon("#f4b400");
    },

    getCompetitorIcon(
      competitorType,
    ) {
      const type =
        Number(competitorType);

      /*
       * Competitor distributor:
       * blue marker with a black outline.
       */
      if (type === 1) {
        return this.getIcon(
          "#4285f4",
          "#000000",
          12,
        );
      }

      /*
       * Competitor dealer.
       */
      return this.getIcon("#4285f4");
    },

    getDealerZIndex(
      dealerCategory,
    ) {
      const category =
        Number(dealerCategory);

      /*
       * Commercial dealers appear above
       * normal dealers.
       */
      if (category === 2) {
        return 2000;
      }

      return 1000;
    },

    async fetchMapData() {
      try {
        this.loading = true;
        this.error = null;
        this.dataReady = false;

        const response =
          await fetchDealersAndCompetitors(
            this.profileId,
            this.token,
          );

        const data =
          response?.data || {};

        if (!data.status) {
          this.error =
            data.message ||
            "Failed to fetch map data.";

          return;
        }

        const toNumber = (...values) => {
          for (const value of values) {
            if (
              value === null ||
              value === undefined ||
              value === ""
            ) {
              continue;
            }

            const numberValue =
              Number(value);

            if (
              Number.isFinite(
                numberValue,
              )
            ) {
              return numberValue;
            }
          }

          return NaN;
        };

        const mapLocation = (item) => {
          const lat = toNumber(
            item?.latitude,
            item?.lat,
          );

          const lng = toNumber(
            item?.longitude,
            item?.lng,
            item?.lon,
          );

          return {
            name:
              item?.name ||
              item?.businessName ||
              item?.business_name ||
              "",

            address:
              item?.address ||
              item?.address1 ||
              "",

            mobile:
              item?.mobile ||
              item?.contact_number ||
              "",

            dealer_category: Number(
              item?.dealer_category ??
                item?.DealerCategory ??
                item?.dealer_cat_id ??
                0,
            ),

            competitor_type: Number(
              item?.competitor_type ??
                item?.CompetitorType ??
                item?.type ??
                0,
            ),

            location: {
              lat,
              lng,
            },
          };
        };

        const hasValidLocation =
          (item) => {
            const lat =
              item?.location?.lat;

            const lng =
              item?.location?.lng;

            return (
              Number.isFinite(lat) &&
              Number.isFinite(lng) &&
              lat >= -90 &&
              lat <= 90 &&
              lng >= -180 &&
              lng <= 180 &&
              !(
                lat === 0 &&
                lng === 0
              )
            );
          };

        /*
         * The backend controls the data scope.
         *
         * Non-distributor login:
         * API returns all applicable records.
         *
         * Distributor login:
         * API returns only that distributor's
         * applicable records.
         *
         * The frontend loads every returned array
         * so hidden layers remain available from
         * the Show/Hide menu.
         */
        this.dealers = (
          data.dealers || []
        )
          .map(mapLocation)
          .filter(hasValidLocation);

        this.competitors = (
          data.competitors || []
        )
          .map(mapLocation)
          .filter(hasValidLocation);

        this.dual = (
          data.dual || []
        )
          .map(mapLocation)
          .filter(hasValidLocation);

        this.distributors = (
          data.distributors || []
        )
          .map(mapLocation)
          .filter(hasValidLocation);

        /*
         * Dealer counts.
         */
        this.dealers_count =
          Number(
            data.dealers_count ?? 0,
          );

        this.dealers_with_location_count =
          this.dealers.length;

        this.normal_dealers_count =
          Number(
            data.normal_dealers_count ??
              0,
          );

        this.normal_dealers_with_location_count =
          Number(
            data.normal_dealers_with_location_count ??
              0,
          );

        this.commercial_dealers_count =
          Number(
            data.commercial_dealers_count ??
              0,
          );

        this.commercial_dealers_with_location_count =
          Number(
            data.commercial_dealers_with_location_count ??
              0,
          );

        /*
         * Competitor counts.
         */
        this.competitors_count =
          Number(
            data.competitors_count ?? 0,
          );

        this.competitors_with_location_count =
          this.competitors.length;

        this.competitor_dealers =
          Number(
            data.competitor_dealers ?? 0,
          );

        this.competitor_dealers_with_location_count =
          Number(
            data.competitor_dealers_with_location_count ??
              0,
          );

        this.competitor_distributors =
          Number(
            data.competitor_distributors ??
              0,
          );

        this.competitor_distributors_with_location_count =
          Number(
            data.competitor_distributors_with_location_count ??
              0,
          );

        /*
         * Dual counts.
         */
        this.dual_count =
          Number(
            data.dual_count ?? 0,
          );

        this.dual_with_location_count =
          this.dual.length;

        /*
         * Distributor counts.
         */
        this.distributors_count =
          Number(
            data.distributors_count ??
              0,
          );

        this.distributors_with_location_count =
          this.distributors.length;

        /*
         * Initial visibility:
         *
         * Distributor login:
         * - Show distributor
         * - Show dealers
         * - Hide competitors
         * - Hide dual
         *
         * Non-distributor login:
         * - Show and focus distributors only
         * - Other layers remain accessible
         *   from the Show/Hide menu
         */
        if (this.isDistributorLogin) {
          this.showDistributors = true;
          this.showDealers = true;
          this.showCompetitors = false;
          this.showDual = false;
        } else {
          this.showDistributors = true;
          this.showDealers = false;
          this.showCompetitors = false;
          this.showDual = false;
        }

        console.log(
          "Dashboard map data:",
          {
            loginType:
              this.normalizedUserCategory,

            apiDistributors:
              data.distributors?.length ||
              0,

            validDistributors:
              this.distributors.length,

            apiDealers:
              data.dealers?.length || 0,

            validDealers:
              this.dealers.length,

            apiCompetitors:
              data.competitors?.length ||
              0,

            validCompetitors:
              this.competitors.length,

            apiDual:
              data.dual?.length || 0,

            validDual:
              this.dual.length,

            showDistributors:
              this.showDistributors,

            showDealers:
              this.showDealers,

            showCompetitors:
              this.showCompetitors,

            showDual:
              this.showDual,
          },
        );

        this.dataReady = true;
      } catch (error) {
        console.error(
          "Dashboard map API error:",
          error,
        );

        this.error =
          error?.response?.data?.message ||
          "Failed to fetch map data.";
      } finally {
        this.loading = false;

        this.$nextTick(() => {
          setTimeout(() => {
            this.tryInitMap();
          }, 300);
        });
      }
    },

    loadGoogleMaps() {
      if (
        window.google &&
        window.google.maps
      ) {
        this.mapsApiReady = true;
        this.tryInitMap();
        return;
      }

      const existingScript =
        document.querySelector(
          'script[data-dashboard-google-maps="true"]',
        );

      if (existingScript) {
        existingScript.addEventListener(
          "load",
          () => {
            this.mapsApiReady = true;
            this.tryInitMap();
          },
          {
            once: true,
          },
        );

        return;
      }

      const script =
        document.createElement("script");

      const googleKey =
        process.env
          .VUE_APP_GOOGLE_MAPS_API_KEY;

      script.dataset.dashboardGoogleMaps =
        "true";

      script.src =
        "https://maps.googleapis.com/" +
        `maps/api/js?key=${googleKey}`;

      script.defer = true;
      script.async = true;

      script.onload = () => {
        this.mapsApiReady = true;
        this.tryInitMap();
      };

      script.onerror = () => {
        this.error =
          "Failed to load Google Maps.";
      };

      document.head.appendChild(script);
    },

    clearAllMarkers() {
      const allMarkers = [
        ...this.distributorMarkers,
        ...this.dealerMarkers,
        ...this.competitorMarkers,
        ...this.dualMarkers,
      ];

      allMarkers.forEach((marker) => {
        if (
          marker &&
          typeof marker.setMap ===
            "function"
        ) {
          marker.setMap(null);
        }
      });

      this.distributorMarkers = [];
      this.dealerMarkers = [];
      this.competitorMarkers = [];
      this.dualMarkers = [];
    },

    fitMapToVisibleMarkers() {
      if (
        !this.map ||
        !window.google ||
        !window.google.maps
      ) {
        return;
      }

      const visibleMarkers = [];

      if (this.showDistributors) {
        visibleMarkers.push(
          ...this.distributorMarkers,
        );
      }

      if (this.showDealers) {
        visibleMarkers.push(
          ...this.dealerMarkers,
        );
      }

      if (this.showCompetitors) {
        visibleMarkers.push(
          ...this.competitorMarkers,
        );
      }

      if (this.showDual) {
        visibleMarkers.push(
          ...this.dualMarkers,
        );
      }

      window.google.maps.event.trigger(
        this.map,
        "resize",
      );

      if (!visibleMarkers.length) {
        this.map.panTo({
          lat: 7.8731,
          lng: 80.7718,
        });

        setTimeout(() => {
          this.map.setZoom(7);
        }, 250);

        return;
      }

      if (visibleMarkers.length === 1) {
        const position =
          visibleMarkers[0].getPosition();

        this.map.panTo(position);

        setTimeout(() => {
          this.map.setZoom(14);
        }, 350);

        return;
      }

      const bounds =
        new window.google.maps
          .LatLngBounds();

      visibleMarkers.forEach(
        (marker) => {
          const position =
            marker.getPosition();

          if (position) {
            bounds.extend(position);
          }
        },
      );

      const center =
        bounds.getCenter();

      this.map.panTo(center);

      setTimeout(() => {
        this.map.fitBounds(bounds, {
          top: 16,
          right: 16,
          bottom: 16,
          left: 16,
        });

        window.google.maps.event
          .addListenerOnce(
            this.map,
            "idle",
            () => {
              const zoom =
                this.map.getZoom();

              if (
                zoom &&
                zoom > 16
              ) {
                this.map.setZoom(16);
              }
            },
          );
      }, 450);
    },

    initMap() {
      if (
        !this.$refs.mapContainer ||
        !window.google ||
        !window.google.maps
      ) {
        return;
      }

      if (!this.map) {
        this.map =
          new window.google.maps.Map(
            this.$refs.mapContainer,
            {
              center: {
                lat: 7.8731,
                lng: 80.7718,
              },

              zoom: 7,

              mapTypeControl: true,
              streetViewControl: false,
              fullscreenControl: false,
            },
          );
      }

      if (!this.sharedInfoWindow) {
        this.sharedInfoWindow =
          new window.google.maps
            .InfoWindow({
              disableAutoPan: true,
            });
      }

      this.clearAllMarkers();

      /*
       * Dealers.
       */
      this.dealers.forEach((dealer) => {
        const marker =
          new window.google.maps.Marker(
            {
              position:
                dealer.location,

              draggable: false,

              title:
                `(${dealer.location.lat},` +
                `${dealer.location.lng})`,

              icon:
                this.getDealerIcon(
                  dealer.dealer_category,
                ),

              zIndex:
                this.getDealerZIndex(
                  dealer.dealer_category,
                ),
            },
          );

        this.addInfoWindow(
          marker,
          dealer,
        );

        this.dealerMarkers.push(
          marker,
        );

        if (this.showDealers) {
          marker.setMap(this.map);
        }
      });

      /*
       * Competitors.
       */
      this.competitors.forEach(
        (competitor) => {
          const marker =
            new window.google.maps
              .Marker({
                position:
                  competitor.location,

                draggable: false,

                title:
                  `(${competitor.location.lat},` +
                  `${competitor.location.lng})`,

                icon:
                  this.getCompetitorIcon(
                    competitor.competitor_type,
                  ),

                zIndex: 1500,
              });

          this.addInfoWindow(
            marker,
            competitor,
          );

          this.competitorMarkers.push(
            marker,
          );

          if (
            this.showCompetitors
          ) {
            marker.setMap(this.map);
          }
        },
      );

      /*
       * Dual.
       */
      this.dual.forEach((dualItem) => {
        const marker =
          this.createMarker(
            dualItem,
            "#28a745",
          );

        marker.setZIndex(4000);

        this.dualMarkers.push(marker);

        if (this.showDual) {
          marker.setMap(this.map);
        }
      });

      /*
       * Distributors.
       */
      this.distributors.forEach(
        (distributor) => {
          const marker =
            new window.google.maps
              .Marker({
                position:
                  distributor.location,

                draggable: false,

                title:
                  `(${distributor.location.lat},` +
                  `${distributor.location.lng})`,

                icon:
                  this.getDistributorIcon(),

                zIndex: 3000,
              });

          this.addInfoWindow(
            marker,
            distributor,
          );

          this.distributorMarkers.push(
            marker,
          );

          if (
            this.showDistributors
          ) {
            marker.setMap(this.map);
          }
        },
      );

      this.$nextTick(() => {
        setTimeout(() => {
          this.fitMapToVisibleMarkers();
        }, 300);
      });
    },

    createMarker(data, color) {
      const marker =
        new window.google.maps.Marker({
          position: data.location,
          draggable: false,

          title:
            `(${data.location.lat},` +
            `${data.location.lng})`,

          icon: this.getIcon(color),
        });

      this.addInfoWindow(
        marker,
        data,
      );

      return marker;
    },

    escapeHtml(value) {
      return String(value ?? "")
        .replaceAll("&", "&amp;")
        .replaceAll("<", "&lt;")
        .replaceAll(">", "&gt;")
        .replaceAll('"', "&quot;")
        .replaceAll("'", "&#039;");
    },

    addInfoWindow(marker, data) {
      marker.addListener(
        "mouseover",
        () => {
          const name =
            this.escapeHtml(
              data?.name || "Unknown",
            );

          const address =
            this.escapeHtml(
              data?.address || "—",
            );

          const mobile =
            this.escapeHtml(
              data?.mobile || "—",
            );

          this.sharedInfoWindow.setContent(`
            <div class="dealer-info">
              <span style="font-weight: 600">
                ${name}
              </span>
              <br>
              Address: ${address}
              <br>
              Mobile: ${mobile}
              <br>
            </div>
          `);

          this.sharedInfoWindow.open(
            this.map,
            marker,
          );

          setTimeout(() => {
            const closeButton =
              document.querySelector(
                ".gm-ui-hover-effect",
              );

            if (closeButton) {
              closeButton.style.display =
                "none";
            }
          }, 10);
        },
      );

      marker.addListener(
        "mouseout",
        () => {
          this.sharedInfoWindow.close();
        },
      );
    },

    createCustomIcon(
      color,
      strokeColor = null,
      strokeWidth = 0,
    ) {
      const strokeAttributes =
        strokeColor
          ? `stroke="${strokeColor}" ` +
            `stroke-width="${strokeWidth}" ` +
            'stroke-linejoin="round"'
          : "";

      const svgIcon = `
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 640 640"
          width="32"
          height="32"
        >
          <path
            fill="${color}"
            ${strokeAttributes}
            d="M128 252.6C128 148.4 214 64 320 64C426 64 512 148.4 512 252.6C512 371.9 391.8 514.9 341.6 569.4C329.8 582.2 310.1 582.2 298.3 569.4C248.1 514.9 127.9 371.9 127.9 252.6zM320 320C355.3 320 384 291.3 384 256C384 220.7 355.3 192 320 192C284.7 192 256 220.7 256 256C256 291.3 284.7 320 320 320z"
          />
        </svg>
      `;

      return {
        url:
          "data:image/svg+xml;charset=UTF-8," +
          encodeURIComponent(svgIcon),

        scaledSize:
          new window.google.maps.Size(
            28,
            28,
          ),

        anchor:
          new window.google.maps.Point(
            14,
            28,
          ),
      };
    },

    createDistributorIcon() {
      const svgIcon = `
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 640 640"
          width="32"
          height="32"
        >
          <path
            fill="#dc3545"
            d="M32 206.1L32 544C32 561.7 46.3 576 64 576C81.7 576 96 561.7 96 544L96 304C96 286.3 110.3 272 128 272L512 272C529.7 272 544 286.3 544 304L544 544C544 561.7 558.3 576 576 576C593.7 576 608 561.7 608 544L608 206.1C608 178.6 590.4 154.1 564.2 145.4L335.2 69.1C325.3 65.8 314.7 65.8 304.8 69.1L75.8 145.4C49.6 154.1 32 178.6 32 206.1zM496 320L144 320L144 384L496 384L496 320zM144 480L496 480L496 416L144 416L144 480zM496 512L144 512L144 576L496 576L496 512z"
          />
        </svg>
      `;

      return {
        url:
          "data:image/svg+xml;charset=UTF-8," +
          encodeURIComponent(svgIcon),

        scaledSize:
          new window.google.maps.Size(
            18,
            18,
          ),

        anchor:
          new window.google.maps.Point(
            9,
            18,
          ),
      };
    },

    seeMore() {
      this.showMapPopup = true;
    },

    closeModal() {
      this.showMapPopup = false;
    },
  },
};
</script>

<style scoped>
.transaction-card {
  border: 1px solid #e0e0e0;
}

.header-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.header-top h5 {
  text-transform: none !important;
}

.see-more-btn {
  width: 100px;
  background-color: #000;
  border: 1px solid #000;
  color: #fff;
  border-radius: 4px;
  padding: 6px 8px;
  transition: all 0.3s ease;
}

.see-more-btn:hover {
  transform: scale(1.05);
}

.dropdown-container {
  position: relative;
}

.menu-btn {
  background-color: #f8f9fa;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 6px 12px;
  color: #333;
  cursor: pointer;
  transition: background 0.3s;
}

.menu-btn:hover {
  background-color: #e2e6ea;
}

.custom-dropdown {
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 5px;
  background: white;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-shadow:
    0 4px 12px
    rgba(0, 0, 0, 0.15);
  z-index: 1000;
  min-width: 180px;
  overflow: hidden;
}

.dropdown-item {
  padding: 10px 15px;
  cursor: pointer;
  font-size: 13px;
  display: flex;
  align-items: center;
  gap: 10px;
  color: #333;
}

.dropdown-item:hover {
  background-color: #f1f1f1;
}

.text-danger {
  color: #dc3545 !important;
}

.text-warning {
  color: #f4b400 !important;
}

.text-primary {
  color: #4285f4 !important;
}

.text-success {
  color: #28a745 !important;
}

.text-muted {
  color: #ccc !important;
}

.spinner-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 150px;
}

.spinner {
  border:
    4px solid
    rgba(0, 0, 0, 0.1);

  border-top:
    4px solid
    #f4b400;

  border-radius: 50%;
  width: 36px;
  height: 36px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.map-legend {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 20px;
  padding-top: 12px;
  justify-content: center;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  white-space: nowrap;
}

.legend-icon {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  flex-shrink: 0;
}

.legend-icon.distributor {
  background-color: #dc3545;
}

.legend-icon.dealer {
  background-color: #f4b400;
}

.legend-icon.competitor {
  background-color: #4285f4;
}

.legend-icon.dual {
  background-color: #28a745;
}

.map {
  width: 100%;
  height: 400px;
  border-radius: 8px;
}

.dealer-info {
  font-size: 13px;
  line-height: 1.4;
  color: #333;
}

.error-container {
  text-align: center;
}

.error-image {
  max-width: 200px;
  display: block;
  margin: 0 auto;
}

.error-message {
  font-size: 15px;
  font-weight: bold;
  color: #053b50;
  padding-top: 10px;
  margin-top: -25px;
}

.hover-tooltip {
  position: relative;
  cursor: pointer;
}

.dealers-tooltip {
  visibility: hidden;
  opacity: 0;
  position: absolute;
  bottom: 130%;
  left: 50%;
  transform: translateX(-50%);
  background-color:
    rgba(51, 51, 51, 0.95);
  color: #fff;
  border-radius: 6px;
  padding: 8px 12px;
  font-size: 12px;
  width: max-content;
  z-index: 100;
  transition:
    opacity 0.2s,
    visibility 0.2s;

  box-shadow:
    0 4px 8px
    rgba(0, 0, 0, 0.2);
}

.dealers-tooltip::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -6px;
  border-width: 6px;
  border-style: solid;
  border-color:
    rgba(51, 51, 51, 0.95)
    transparent
    transparent
    transparent;
}

.hover-tooltip:hover .dealers-tooltip {
  visibility: visible;
  opacity: 1;
}

.tooltip-row {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 4px;
}

.tooltip-row:last-child {
  margin-bottom: 0;
}
</style>